module.exports = __webpack_public_path__ + "static/media/location-maps-letter-g-arrow.2bb19e48.png";